<template>
    <div>

      <Modal v-model="modal" title="Update Status" draggable :class-name="showFooter.includes(value)?'action-modal':''"
                             :width="popupWidth[value]?popupWidth[value]:450" :footer-hide="showFooter.includes(value)?false:true">
            <div v-if="order">
<!--              <Card style="min-width:350px" v-if="order">-->
<!--                <p slot="title">Update status</p>-->
                <div>
                    <ul style="list-style: none; font-size: 14px">
                        <li>
                            <h3>{{order.orderNumber}}</h3> <span style="float: right;margin-top: -20px;font-weight: bold;color: green;">{{order.internalStatus.name}}</span>
                        </li>
                        <li style="display: flex; margin-top: 10px;">
                            <h4>{{order.pickuppartyobject.address[0].city}} </h4>
                            <i class="fas fa-exchange-alt exchange-icon" ></i>
                            <h4>{{order.droppingpartyobject.address[0].city}} </h4>
                        </li>
                        <li style="display: flex; margin-top: 10px;">
                          <span style="color: #a9a9a9; margin-right: 4px;">Client</span>:
                          {{hotInstance.getDataAtRowProp(row, 'clientName')}}
                        </li>
                        <li style="display: flex; margin-top: 10px;">
                          <span style="color: #a9a9a9; margin-right: 4px;">Pickup</span>:
                          {{hotInstance.getDataAtRowProp(row, 'pickupPartyName')}} ( {{order.pickupAreaGroup}} )<br>
                          &nbsp; {{pickupPartyAddress}}
                            <!-- <i class="fas fa-exchange-alt exchange-icon" />
                            <p>{{hotInstance.getDataAtRowProp(row, 'dropPartyName')}}</p> -->
                        </li>
                    </ul>
<!--                    <div v-if="value === Constants.internalStatus.underPickupProcess" style="float: right;margin: -32px 0 0 0;">-->
<!--                        <Button type="primary" @click="onSendPickupVehicle(order.id)" :loading="loader1">-->
<!--                            <span v-if="!loader1">Send Pickup Vehicle</span>-->
<!--                            <span v-else>Loading...</span>-->
<!--                        </Button>-->
<!--                        <ul style="color: red; list-style: none" v-if="errMessages.length">-->
<!--                            <li v-for="(err, index) in errMessages" :key="index">{{err}}</li>-->
<!--                        </ul>-->
<!--                    </div>-->
<!--                  <div v-if="value === Constants.internalStatus.inProcessOfDeparture" style="float: right;margin: -32px 0 0 0;">-->
<!--                      <Button type="primary" @click="onWaitingForDeparture(order.id, order.orderDetails.id)" :loading="loader1">-->
<!--                        <span v-if="!loader1">Waiting For Departure</span>-->
<!--                        <span v-else>Loading...</span>-->
<!--                      </Button>-->
<!--                      <ul style="color: red" v-if="errMessages.length">-->
<!--                        <li v-for="(err, index) in errMessages" :key="index">{{err}}</li>-->
<!--                      </ul>-->

<!--                    </div>-->
                </div>
                    <Divider />
                <div>
                    <div v-if="value === Constants.internalStatus.pendingForApproval" style="display: flex; justify-content: flex-end; margin-top: 20px;">
                        <Button type="primary" @click.stop="approveOrderWithInsertClientInvoice(order.id, Constants.internalStatus.pendingForOrderConfirmation, 'loader1')" :loading="loader1">
                            <span v-if="!loader1">Approve</span>
                            <span v-else>Loading...</span>
                        </Button>
                        <Button style="margin-left: 4px"
                                @click.stop="onUpdateStatus(order.id, Constants.internalStatus.rejected, 'loader2')" :loading="loader2">
                            <span v-if="!loader2">Reject</span>
                            <span v-else>Loading...</span>
                        </Button>
                    </div>

                    <div v-if="value === Constants.internalStatus.pendingForOrderConfirmation" style="display: flex; justify-content: flex-end; margin-top: 20px;">
                        <Button @click.stop="onPickupConfirmation(order.id, order.orderDetails.id, 'loader1')" :loading="loader1">
                            <span v-if="!loader1">Confirm But Not Ready</span>
                            <span v-else>Loading...</span>
                        </Button>
                        <Button style="margin-left: 4px"
                                @click.stop="onPickupConfirmationAndReadiness(order.id, order.orderDetails.id, 'loader2')" :loading="loader2">
                            <span v-if="!loader2">Confirm & Ready For Pickup</span>
                            <span v-else>Loading...</span>
                        </Button>
                    </div>

                    <div style="display: flex; justify-content: flex-end; margin-top: 20px;" v-if="value === Constants.internalStatus.orderNotReady">
                        <Button @click.stop="onPickupConfirmationAndReadiness(order.id, order.orderDetails.id, 'loader1')" :loading="loader1">
                            <span v-if="!loader1">Order Ready for Pickup</span>
                            <span v-else>Loading...</span>
                        </Button>
                    </div>


                    <div v-if="value === Constants.internalStatus.underPickupProcess">
                        <Row :gutter="10">
                            <Col span="8">
<!--                                <Tabs v-model="menu" type="card">-->
<!--                                    <TabPane label="Local Vehicle" :icon="order.orderDetails.pickupVehicleAssignId?'ios-checkmark-circle':''" name="1">-->

<!--                                    </TabPane>-->
<!--                                    <TabPane label="Create LR" :icon="order.orderDetails.lrObject.lrName?'ios-checkmark-circle':''" name="2"></TabPane>-->
<!--                                    <TabPane label="SMS/Email" :icon="order.orderDetails.lrObject.isEmailSent?'ios-checkmark-circle':''" name="3"></TabPane>-->
<!--                                </Tabs>-->
                                <Menu :active-name="1" @on-select="menu=$event" width="auto">
                                    <MenuGroup title="Actions">
                                        <MenuItem name="1"><i class="fas fa-truck-pickup"></i>Select Local Vehicle
                                            <i class="fas fa-check-circle" style="color: green; margin-left: 8px" v-if="order.orderDetails.pickupVehicleAssignId"></i>
                                        </MenuItem>
                                        <MenuItem name="2"><i class="fas fa-receipt"></i>Create LR
                                            <i class="fas fa-check-circle" style="color: green; margin-left: 8px" v-if="order.orderDetails.lrObject.lrName"></i>
                                        </MenuItem>
                                        <MenuItem name="3"><i class="fas fa-envelope"></i>Send Vehicle SMS/Email
                                            <i class="fas fa-check-circle" style="color: green; margin-left: 8px" v-if="order.orderDetails.lrObject.isEmailSent"></i>
                                        </MenuItem>
<!--                                        <MenuItem :name="4"><i class="fas fa-trailer"></i>Send Vehicle For Pickup material</MenuItem>-->
                                    </MenuGroup>
                                </Menu>
                            </Col>
                            <Col span="16">
                                <template v-if="menu === '1'">
                                    <!--<Card v-if="order.orderDetails.pickupVehicleAssignId">-->
                                        <!--<p slot="title">SUR20200320004</p>-->
                                        <!--<a href="#" slot="extra" @click.stop="onAssignVehicle()" v-if="!showVehicle">-->
                                            <!--<Icon type="ios-loop-strong"></Icon>-->
                                            <!--Change-->
                                        <!--</a>-->
                                        <!--<div>-->
                                            <!--<p>{{hotInstance.getDataAtRowProp(row, 'tempoPlateNum')}}</p>-->
                                            <!--<p>Driver name</p>-->
                                            <!--<p>Phone</p>-->
                                        <!--</div>-->
                                    <!--</Card>-->
                                    <div v-if="order.orderDetails.pickupVehicleAssignId">{{hotInstance.getDataAtRowProp(row, 'tempoPlateNum')}}</div>
                                    <Button @click.stop="onAssignVehicle()" v-if="!showVehicle">
                                        Show Tempo</Button>
                             <!--------- Commented temporarily ------------- -->
                                    <Button style="margin-left: 10px" @click.stop="unlinkTempo(order.id, order.orderDetails.id, order.internalstatus)"
                                            v-if="order.orderDetails.pickupVehicleAssignId">Unlink Tempo</Button>
                             <!-- -------------x----------------x--------x--- -->
                                    <vehicle-assignment :orderId="order.id" :isComponentLoadedInToDo="true"
                                                        v-if="showVehicle" :toDoStage="toDoStage"></vehicle-assignment>
                                </template>
                                <template v-if="menu === '2'">
                                    <Form>
                                        <FormItem label="LR Name"><Input v-model="lrName"/></FormItem>
                                    </Form>
                                    <Button @click="onEnterLR(order.orderDetails.id, order.orderDetails.lrObject)"
                                            :loading="loader1" :disabled="!lrName" style="float: right">
                                        <span v-if="!loader1">Save</span>
                                        <span v-else>Loading...</span>
                                    </Button>
                                </template>
                                <template v-if="menu === '3'">
                                    <div v-if="order.orderDetails.lrObject.isEmailSent">Email Already Sent.</div>
                                    <Button v-else @click="onSendPickupEmail(order.orderDetails.id, order.orderDetails.lrObject)" :loading="loader1">
                                        <span v-if="!loader1">Email Sent</span>
                                        <span v-else>Loading...</span>
                                    </Button>
                                </template>
                                <!--<template v-if="menu === '4'">-->
                                    <!--<Button @click="onSendPickupVehicle(order.id)" :loading="loader1">-->
                                        <!--<span v-if="!loader1">Send Pickup Vehicle</span>-->
                                        <!--<span v-else>Loading...</span>-->
                                    <!--</Button>-->
                                    <!--<ul style="color: red" v-if="errMessages.length">-->
                                        <!--<li v-for="(err, index) in errMessages" :key="index">{{err}}</li>-->
                                    <!--</ul>-->

                                <!--</template>-->
                            </Col>
                        </Row>
                    </div>

                    <div v-if="value === Constants.internalStatus.readyForPickup" style="display: flex; justify-content: flex-end; margin-top: 20px;">
                        <Button @click.stop="onUpdateStatus(order.id, Constants.internalStatus.tempoOnTheWayToPickupLoad, 'loader1')" :loading="loader1">
                            <span v-if="!loader1">Send Vehicle For Pickup Material</span>
                            <span v-else>Loading...</span>
                        </Button>
                    </div>

                    <div v-if="value === Constants.internalStatus.tempoOnTheWayToPickupLoad" style="display: flex; justify-content: flex-end; margin-top: 20px;">
                        <Button @click.stop="onUpdateStatus(order.id, Constants.internalStatus.tempoWaitingForLoadingMaterial, 'loader1')" :loading="loader1">
                            <span v-if="!loader1">Submit LR In Company</span>
                            <span v-else>Loading...</span>
                        </Button>
                    </div>

                    <div v-if="value === Constants.internalStatus.tempoWaitingForLoadingMaterial" style="float: right;min-height: 140px">
                        <Form label-position="top">
                            <FormItem label="Tempo Action">
                                <RadioGroup v-model="tempoActionStatus">
                                    <Radio label="1">Material Loaded</Radio>
                                    <Radio label="2" style="margin-left: 20px">Empty Return</Radio>
                                </RadioGroup>
                            </FormItem>
                        </Form>

                        <template v-if="tempoActionStatus==='1'">
                            <Button @click.stop="onUpdateStatus(order.id, Constants.internalStatus.underBillingProcess, 'loader1')" :loading="loader1">
                                <span v-if="!loader1">Material Loaded & Proceed to Next Stage</span>
                                <span v-else>Loading...</span>
                            </Button>
                        </template>
                        <template v-if="tempoActionStatus==='2'">
                            <Button @click.stop="onPickupLater(order.id, Constants.internalStatus.orderNotReady, order.orderDetails.id, 'loader1')" :loading="loader1">
                                <span v-if="!loader1">Pickup later</span>
                                <span v-else>Loading...</span>
                            </Button>

                            <Button @click.stop="onCancelPickup(order.id, Constants.internalStatus.readyForFinalDelivery, order.materials, 'loader2', order)" :loading="loader2"
                                    style="margin-left: 5px">
                                <span v-if="!loader2">Cancel Pickup</span>
                                <span v-else>Loading...</span>
                            </Button>
                        </template>
                    </div>

                    <div v-if="value === Constants.internalStatus.underBillingProcess" style="display: flex; justify-content: flex-end; margin-top: 20px;">
                        <Button @click.stop="onUpdateStatus(order.id, Constants.internalStatus.onTheWayToPickupCityWarehouse, 'loader1')" :loading="loader1">
                            <span v-if="!loader1">Left From Company</span>
                            <span v-else>Loading...</span>
                        </Button>
                    </div>

                    <div v-if="value === Constants.internalStatus.onTheWayToPickupCityWarehouse" style="display: flex; justify-content: flex-end; margin-top: 20px;">
                        <Button @click.stop="onUpdateStatus(order.id, Constants.internalStatus.underVerificationAtPickupCityWarehouse, 'loader1')" :loading="loader1">
                            <span v-if="!loader1">Reached Pickup City Warehouse</span>
                            <span v-else>Loading...</span>
                        </Button>
                    </div>

                    <div v-if="value === Constants.internalStatus.underVerificationAtPickupCityWarehouse||
                       value === Constants.internalStatus.atDestinationCityWarehouse" style="width: 30vw">
                        <Form :model="dispatchForm" ref="dispatchForm" :label-width="110">
                          <FormItem label="Size" prop="materialSize">
                            <RadioGroup v-model="dispatchForm.materialSize">
                              <Radio style="text-transform: capitalize" :label="m" v-for="(m, index) in Constants.materialSizes" :key="index"/>
                            </RadioGroup>
                          </FormItem>
                            <FormItem prop="finalQty" label="Final Qty">
                                <Input v-model="dispatchForm.finalQty"/>
                            </FormItem>
                            <FormItem prop="finalWt" label="Final Wt.">
                                <Input v-model="dispatchForm.finalWt"/>
                            </FormItem>
                            <FormItem prop="breakageQty" label="Breakage Qty">
                                <Input v-model="dispatchForm.breakageQty"/>
                            </FormItem>
                            <FormItem prop="breakageNote" label="Breakage Note">
                                <Input type="textarea" v-model="dispatchForm.breakageNote"/>
                            </FormItem>
                            <FormItem prop="missingQty" label="Missing Qty">
                                <Input v-model="dispatchForm.missingQty"/>
                            </FormItem>
                            <FormItem prop="missingNote" label="Missing Note">
                                <Input type="textarea" v-model="dispatchForm.missingNote"/>
                            </FormItem>
                        </Form>
                    </div>

                    <div v-if="value === Constants.internalStatus.inProcessOfDeparture" style="margin-left: 8px;">
                        <Row :gutter="10">
                            <Col span="8">
                                <Menu active-name="1" @on-select="menu=$event" width="auto">
                                    <MenuGroup title="Actions">
                                        <MenuItem name="1"><i class="fas fa-truck-pickup"></i>Select Transport Vehicle
                                            <i class="fas fa-check-circle" style="color: green; margin-left: 8px" v-if="order.orderDetails.transportVehicleAssignId"></i>
                                        </MenuItem>
                                        <MenuItem name="2"><i class="fas fa-receipt"></i>Eway Bill No.
                                            <i class="fas fa-check-circle" style="color: green; margin-left: 8px" v-if="order.orderDetails.ewayBillNo&&order.orderDetails.isEwayBillVerified"></i>
                                        </MenuItem>
                                        <MenuItem name="3"><i class="fas fa-receipt"></i>Update LR
                                            <i class="fas fa-check-circle" style="color: green; margin-left: 8px" v-if="order.orderDetails.lrObject.lrName"></i>
                                        </MenuItem>
                                        <MenuItem name="4"><i class="fas fa-envelope"></i>Carry Bill
                                            <i class="fas fa-check-circle" style="color: green; margin-left: 8px" v-if="order.orderDetails.carryBill !== null"></i>
                                        </MenuItem>
        <!--                                <MenuItem name="5"><i class="fas fa-trailer"></i>Ready To Depart</MenuItem>-->
                                    </MenuGroup>
                                </Menu>
                            </Col>
                            <Col span="16">
                                <template v-if="menu === '1'">
                                    <div v-if="order.orderDetails.transportVehicleAssignId">
                                        {{hotInstance.getDataAtRowProp(row, 'truckPlateNumber')}}
                                        <Button @click="unlinkTruck(order.id, order.orderDetails.id, order.internalstatus)" :loader="loader1" style="margin-left: 15px">
                                            <span v-if="!loader1">Unlink Truck</span>
                                            <span v-else>Loading...</span>
                                        </Button>
                                    </div>
                                    <Button @click.stop="onAssignVehicle()" v-if="!showVehicle">
                                        Show Truck</Button>
                                    <vehicle-assignment :orderId="order.id" :isComponentLoadedInToDo="true"
                                                        v-if="showVehicle" :toDoStage="toDoStage"/>
                                </template>
                                <template v-if="menu === '2'">
                                    <Form>
                                        <FormItem label="Eway Bill No.">
                                            <Input v-model="ewayBillNo"/>
                                        </FormItem>

                                                <FormItem label="Is Eway Bill Verified">
                                                    <i-switch v-model="isEwayBillVerified" size="large">
                                                        <span slot="open">ON</span><span slot="close">OFF</span>
                                                    </i-switch>
                                                </FormItem>
                                            </Form>
                                            <Button @click="addEwayBillDetails(order.orderDetails.id)"
                                                    :loading="loader1" :disabled="!ewayBillNo" style="float: right">
                                                <span v-if="!loader1">Save</span>
                                                <span v-else>Loading...</span>
                                            </Button>
                                        </template>
                                        <template v-if="menu === '3'">
                                            <Form>
                                                <FormItem label="LR Name"><Input v-model="lrName"/></FormItem>
                                            </Form>
                                            <Button @click="onEnterLR(order.orderDetails.id, order.orderDetails.lrObject)"
                                                    :loading="loader1" :disabled="!lrName" style="float: right">
                                                <span v-if="!loader1">Save</span>
                                                <span v-else>Loading...</span>
                                            </Button>
                                        </template>
                                        <template v-if="menu === '4'">
                                            <Form label-position="top">
                                                <FormItem label="Carry Bill">
                                                    <RadioGroup v-model="carryBill">
                                                        <Radio label="Yes"></Radio>
                                                        <Radio label="No"></Radio>
                                                    </RadioGroup>
                                                </FormItem>
                                            </Form>
                                            <Button @click="updateCarryBill(order.orderDetails.id)" :loading="loader1"
                                                    :disabled="carryBill === 'None'" style="float: right">
                                                <span v-if="!loader1">Save</span>
                                                <span v-else>Loading...</span>
                                            </Button>
                                        </template>
        <!--                                <template v-if="menu === '5'">-->
        <!--                                    <Button @click="onWaitingForDeparture(order.id, order.orderDetails.id)" :loading="loader1">-->
        <!--                                        <span v-if="!loader1">Waiting For Departure</span>-->
        <!--                                        <span v-else>Loading...</span>-->
        <!--                                    </Button>-->
        <!--                                    <ul style="color: red" v-if="errMessages.length">-->
        <!--                                        <li v-for="(err, index) in errMessages" :key="index">{{err}}</li>-->
        <!--                                    </ul>-->

        <!--                                </template>-->
                                    </Col>
                                </Row>
                            </div>

                    <div v-if="value === Constants.internalStatus.waitingForDeparture" style="justify-content: flex-end; margin-top: 20px;">
                        <Button @click.stop="onWayToDropCityWarehouse(order.orderDetails.transportVehicleAssignId, 'loader1')" :loading="loader1">
                            <span v-if="!loader1">On The Way To Drop City Warehouse</span>
                            <span v-else>Loading...</span>
                        </Button>
                        <template v-if="errMessages.length">
                            <p style="margin:5px 0px">The Following Orders are still not in <i>'Waiting For Departure'</i> stage</p>
                            <ul style="color: red; margin: 10px">
                                <li v-for="(err, index) in errMessages" :key="index">{{err}}</li>
                            </ul>
                        </template>

                    </div>

                    <div v-if="value === Constants.internalStatus.onTheWayToDropCityWarehouse" style="justify-content: flex-end; margin-top: 20px;">
                        <Button @click.stop="onAtDestinationCityWarehouse(order.orderDetails.transportVehicleAssignId, 'loader1')" :loading="loader1">
                            <span v-if="!loader1">At Destination City Warehouse</span>
                            <span v-else>Loading...</span>
                        </Button>
                        <template v-if="errMessages.length">
                            <p style="margin:5px 0px">The Following Orders are still not in <i>'On The Way To Drop City Warehouse'</i> stage</p>
                            <ul style="color: red; margin: 10px">
                                <li v-for="(err, index) in errMessages" :key="index">{{err}}</li>
                            </ul>
                        </template>

                    </div>

                    <div v-if="value === Constants.internalStatus.readyForFinalDelivery" style="display: flex; justify-content: flex-end; margin-top: 20px;">
                        <Button v-if="order.materials.boxes === 'Empty Return Charge'" @click.stop="onUpdateStatus(order.id, Constants.internalStatus.cancel, 'loader1')" :loading="loader1">
                            <span v-if="!loader1">Move to Cancel Stage</span><span v-else>Loading...</span>
                        </Button>
                        <Button v-else @click.stop="onUpdateStatus(order.id, Constants.internalStatus.completed, 'loader1')" :loading="loader1">
                            <span v-if="!loader1">Delivered</span><span v-else>Loading...</span>
                        </Button>
                    </div>
                </div>
            </div>
            <div slot="footer">
              <template v-if="value === Constants.internalStatus.underVerificationAtPickupCityWarehouse">
                <Button @click="onDispatchVerification(order.orderDetails.id, value, order.id,
                                order.orderDetails.dispactchVerification, order.materials, Constants.internalStatus.inProcessOfDeparture)" :loading="loader1">
                  <span v-if="!loader1">Save</span>
                  <span v-else>Loading...</span>
                </Button>
              </template>
              <template v-if="value === Constants.internalStatus.atDestinationCityWarehouse">
                <Button @click="onDispatchVerification(order.orderDetails.id, value, order.id,
                                order.orderDetails.dispactchVerification, order.materials, Constants.internalStatus.readyForFinalDelivery)" :loading="loader1">
                  <span v-if="!loader1">Save</span>
                  <span v-else>Loading...</span>
                </Button>
              </template>
              <Button style="margin-left: 10px" @click="closeModal()">Cancel</Button>
            </div>

      </Modal>

        <!--<div v-if="isRenderer" style="text-align: center" :class="cellProperties.readOnly?'cell-readonly':''">-->
            <!--<template v-if="$parent.$parent.$parent.orders[row]">-->
            <!--{{$parent.$parent.$parent.orders[row].internalStatus.name}}-->
            <!--</template>-->
        <!--</div>-->
    <cancel-order-popup :formDialog.sync="cancelOrderDialog" :order="order" @closeMainModal="closeModal"/>
    </div>
</template>

<script>
    import {BaseEditorComponent} from '@handsontable/vue'
    import {Constants} from "../../Constants/Constant"
    import {
      ADD_ORDER_NOTE,
      generate_UPDATE_ORDER_DATA,
      UPDATE_ORDER_INSERT_CLIENT_INVOICE
    } from "../../graphql/mutations/orders"
    import VehicleAssignment from "../Manage Order/VehicleAssignment"
    import {VERIFY_ORDERS_BY_TRUCK_ORDER_ID_AND_STAGE_ID, UPDATE_ORDERS_AND_TRUCKORDER_STATUS_USING_TRUCK_ORDER_ID}
            from "../../graphql/queries/truckOrders"
    import moment from 'moment'
    import {bus} from "../../main"
    import CancelOrderPopup from "./CancelOrderPopup";
    import {getAddressString} from "./RendererFunctions";

    export default {
        name: "ActionPopup",
        components: {CancelOrderPopup, VehicleAssignment},
        provide() {
            return {
                getManageOrderDrawer: () => this.manageOrderDrawer,
                setManageOrderDrawer: (data) => { this.manageOrderDrawer = data },
                getOrder: () => this.order,
                closeAssignVehicleDialog: (data) => { },
            }
        },
        extends: BaseEditorComponent,
        data:function () {
            return{
                Constants: Constants,
                userObj: JSON.parse(localStorage.getItem('tatkalorri')).userObj,
                popupWidth:{[Constants.internalStatus.underPickupProcess]: 650, [Constants.internalStatus.inProcessOfDeparture]: 650,
                            [Constants.internalStatus.underVerificationAtPickupCityWarehouse]: 500},
                showFooter: [Constants.internalStatus.underVerificationAtPickupCityWarehouse, Constants.internalStatus.atDestinationCityWarehouse],
                modal: false,
                order: null,
                hotInstance: null,
                TD: null,
                row: null,
                col: null,
                prop: null,
                originalValue: null,
                value: '',
                cellProperties: null,
                isVisible: false,
                isEditor: null,
                isRenderer: null,
                editorElement: null,
                style: {
                    position: "absolute",
                    background: "#fff",
                    zIndex: 999,
                    border: "1px solid #000",
                    left: "0px",
                    top: "0px",
                    // maxHeight: '325px',
                    // overflowY: 'scroll'
                },
                loader1: false,
                loader2: false,
                showVehicle: false,
                toDoStage: 'assign_local_transport',
                dispatchForm: {
                    finalQty: '',
                    finalWt: 0,
                    breakageQty: 0,
                    breakageNote: 0,
                    missingQty: 0,
                    missingNote: 0,
                    materialSize: null
                },
                menu: '1',
                lrName: '',
                errMessages: [],
                ewayBillNo: '',
                isEwayBillVerified: false,
                carryBill: 'None',
                tempoActionStatus: '1',
                cancelOrderDialog: false
            }
        },
        computed: {
          pickupPartyAddress: function(){
            if(this.order?.orderDetails.pickupPoint.pickupPartyId){
              return getAddressString(this.order.orderDetails.pickupPoint)
            }else if(this.order){
              return getAddressString(this.order.pickuppartyobject.address[0])
            }
          }
        },
        methods:{
            stopMousedownPropagation: function(e) {
                e.stopPropagation();
            },
            prepare: function(row, col, prop, td, originalValue, cellProperties) {
                BaseEditorComponent.options.methods.prepare.call(this, row, col, prop, td, originalValue, cellProperties);
                const tdPosition = td.getBoundingClientRect();

                this.style.left = tdPosition.left + window.pageXOffset + 'px';
                this.style.top = tdPosition.top + window.pageYOffset + 'px';
            },
            open: function() {
                // console.log('open method fired')
                this.isVisible = true
                this.modal = true
                let screen = this.$parent.$parent.$parent.screen
                let ordersVariable = screen + '_orders'
                let pRow = this.hotInstance?.toPhysicalRow(this.row)                             //When accessing original array
                this.order = this.$parent.$parent.$parent[ordersVariable][pRow]

                if(this.value === Constants.internalStatus.underVerificationAtPickupCityWarehouse||
                   this.value === Constants.internalStatus.atDestinationCityWarehouse){
                    this.dispatchForm = { finalQty: '', finalWt: 0, breakageQty: 0, breakageNote: 0, missingQty: 0,
                                          missingNote: 0, materialSize: this.order.orderDetails.materialSize }
                }else if(this.value === Constants.internalStatus.underPickupProcess){
                    this.lrName = this.order.orderDetails.lrObject.lrName
                    this.menu = '1'
                    this.errMessages = []
                }else if(this.value === Constants.internalStatus.tempoWaitingForLoadingMaterial){
                    this.tempoActionStatus = '1'
                }else if(this.value === Constants.internalStatus.inProcessOfDeparture){
                    this.lrName = this.order.orderDetails.lrObject.lrName
                    this.ewayBillNo = this.order.orderDetails.ewayBillNo
                    this.isEwayBillVerified = this.order.orderDetails.isEwayBillVerified
                    if(this.order.orderDetails.carryBill === null){
                        this.carryBill = 'None'
                    }else if(this.order.orderDetails.carryBill === false){
                        this.carryBill = 'No'
                    }else {
                        this.carryBill = 'Yes'
                    }
                    this.menu = '1'
                    this.errMessages = []
                }else if(this.value === Constants.internalStatus.waitingForDeparture||
                    this.value === Constants.internalStatus.onTheWayToDropCityWarehouse){
                    this.errMessages = []
                }

                // console.log('row', this.order)
            },
            focus: function() {
                console.log('focus method fired')
                this.isVisible = true;
            },
            close: function() {
                this.showVehicle = false
                this.isVisible = false;
            },
          closeModal: function() {
                this.showVehicle = false
                this.modal = false;
            },
            setValue: function(value) {                    /* Customized due to filter options */
                let val = this.hotInstance?.getDataAtRowProp(this.row, 'internalStatusId');
                this.value = val;
            },
            getValue: function() {                         /* Customized due to filter options */
              let val = this.hotInstance?.getDataAtRowProp(this.row, 'internalStatus');
              return val;
            },
            async approveOrderWithInsertClientInvoice(id, internalStatus, loaderStr){         /* When Approve Order */
              this[loaderStr] = true;
              let response = await this.$apollo.mutate({
                mutation: UPDATE_ORDER_INSERT_CLIENT_INVOICE,
                variables: {
                  id: id,
                  order: {
                    internalstatus: internalStatus, lastStageUpdatedOn : moment().format(),
                    lastStageUpdatedBy : this.userObj.user.id
                  },
                  clientInvoice: {
                    statusId: Constants.ClientInvoiceStatus.New, orderId: id, clientId: this.order.clientobject.id,
                    createdBy: this.userObj.user.id, updatedBy: this.userObj.user.id
                  },
                }
              });
              if(response.data) {
                this.$Message.success('Order updated successfully!');
                this[loaderStr] = false;
                this.close();
                this.closeModal();
                this.finishEditing();
              }
            },
            onUpdateStatus(id, internalStatus, loaderStr){
               let obj = { internalstatus: internalStatus, lastStageUpdatedOn : moment().format(),
                           lastStageUpdatedBy : this.userObj.user.id}
               let table = 'orders'
               this.updateRecord(id, obj, table, loaderStr)
            },
            async onPickupConfirmation(orderId, orderDetailId, loaderStr){
               obj =  {pickupConfirmation: 'Done'}
               await this.updateRecord(orderDetailId, obj, 'orderDetails', loaderStr)

              let obj = { internalstatus: Constants.internalStatus.orderNotReady, lastStageUpdatedOn : moment().format(),
                lastStageUpdatedBy : this.userObj.user.id}
              this.updateRecord(orderId, obj, 'orders', loaderStr)
            },
            async onPickupConfirmationAndReadiness(orderId, orderDetailId, loaderStr){
               obj =  {
                   pickupConfirmation: 'Done',
                   orderReadiness: {isOrderReady: true, pickupDate: ''}
               }
               await this.updateRecord(orderDetailId, obj, 'orderDetails', loaderStr)

              let obj = { internalstatus: Constants.internalStatus.underPickupProcess, lastStageUpdatedOn : moment().format(),
                lastStageUpdatedBy : this.userObj.user.id}
              this.updateRecord(orderId, obj, 'orders', loaderStr)
            },
            onEnterLR(id, lrObject){
                let obj = { lrObject: {isEmailSent: lrObject.isEmailSent, lrName: this.lrName, islrReady: true} }
                this.updateRecord(id, obj, 'orderDetails', 'loader1', false)
            },
            onSendPickupEmail(id, lrObject){
               let obj = {lrObject: {isEmailSent: true, lrName: lrObject.lrName, islrReady: lrObject.islrReady}}
               this.updateRecord(id, obj, 'orderDetails', 'loader1', false)
            },
            onReadyForPickup(id){
              this.errMessages = []
                let hasError = false
                if(!this.order.orderDetails.pickupVehicleAssignId){
                    this.errMessages.push('Select Local Vehicle')
                    hasError = true
                }
                if(!this.order.orderDetails.lrObject.lrName){
                    this.errMessages.push('Create LR')
                    hasError = true
                }
                if(!this.order.orderDetails.lrObject.isEmailSent){
                    this.errMessages.push('Send Pickup Email/SMS')
                    hasError = true
                }
                if(!hasError){
                    let obj = { internalstatus: Constants.internalStatus.readyForPickup, lastStageUpdatedOn : moment().format(),
                                lastStageUpdatedBy : this.userObj.user.id }
                    this.updateRecord(id, obj, 'orders', 'loader1')
                }
            },
            async onPickupLater(orderId, internalStatus, orderDetailId, loaderStr){
              obj = {
                orderReadiness: { pickupDate: '', isOrderReady: false},
                lrObject: { lrName: '', islrReady: false, isEmailSent: false},
                pickupVehicleAssignId: null
              }
              await this.updateRecord(orderDetailId, obj, 'orderDetails', loaderStr)

                let obj = { internalstatus: internalStatus, lastStageUpdatedOn : moment().format(),
                            lastStageUpdatedBy : this.userObj.user.id}
                this.updateRecord(orderId, obj, 'orders', loaderStr)
            },
            onCancelPickup(id, internalStatus, materials, loaderStr){
              this.cancelOrderDialog = true
              /*let cancelNote = '';
                this.$Modal.confirm({
                  title: 'Cancel Order',
                  render: (h) => {
                    return h('Input', {
                      props: {
                        value: cancelNote,
                        autofocus: true,
                        placeholder: 'Enter Cancel note...',
                      },
                      on: {
                        input: (val) => {
                          cancelNote = val;
                        }
                      }
                    })
                  },
                  onOk: () => {
                    if(!cancelNote){
                      this.$Message.error('Please enter Cancel note!');
                      return;
                    }
                    materials.boxes = 'Empty Return Charge'
                    let obj = { internalstatus: internalStatus, lastStageUpdatedOn : moment().format(),
                      lastStageUpdatedBy : this.userObj.user.id, materials: materials}
                    this.updateRecord(id, obj, 'orders', loaderStr)

                    this.insertCancelNote(id, cancelNote)
                  }
                }) */
            },
            async onDispatchVerification(orderDetailId, internalStatusId, orderId, dispactchVerification, materials, updateBy_internalStatusId){
                let dv = []
                if(dispactchVerification && Object.prototype.toString.call(dispactchVerification) == '[object Array]'){
                    dv = dispactchVerification;
                }
                dv.unshift({
                    createdAt : moment().format('DD-MM-YYYY hh:mm:ss a'),
                    createdBy: this.userObj.user.id,
                    internalStatusId: internalStatusId,
                    finalQuantity: this.dispatchForm.finalQty,
                    finalWeight: this.dispatchForm.finalWt,
                    breakageQuantity: this.dispatchForm.breakageQty,
                    breakageNote: this.dispatchForm.breakageNote,
                    missingQuantity: this.dispatchForm.missingQty,
                    missingNote: this.dispatchForm.missingNote
                })

                await this.updateRecord(orderDetailId, { dispactchVerification: dv, materialSize:this.dispatchForm.materialSize }, 'orderDetails', 'loader1')

                if(this.dispatchForm.finalQty||this.dispatchForm.finalWt){
                    if(this.dispatchForm.finalQty){materials.boxes = this.dispatchForm.finalQty}
                    if(this.dispatchForm.finalWt){materials.kg = this.dispatchForm.finalWt}
                   await this.updateRecord(orderId, {materials: materials}, 'orders', 'loader1')
                }

                let obj = { internalstatus: updateBy_internalStatusId, lastStageUpdatedOn : moment().format(),
                           lastStageUpdatedBy : this.userObj.user.id }
                this.updateRecord(orderId, obj, 'orders', 'loader1')
            },
            async unlinkTempo(orderId, orderDetailId, stage){
                let obj = { pickupVehicleAssignId: null}
                await this.updateRecord(orderDetailId, obj, 'orderDetails', 'loader1')

              /* -------- Change Order status to 'Under Pickup Process' --------- */
                if([Constants.internalStatus.readyForPickup, Constants.internalStatus.tempoOnTheWayToPickupLoad, Constants.internalStatus.tempoWaitingForLoadingMaterial,
                    Constants.internalStatus.underBillingProcess, Constants.internalStatus.onTheWayToPickupCityWarehouse,
                    Constants.internalStatus.underVerificationAtPickupCityWarehouse].includes(stage)){
                    obj = { internalstatus: Constants.internalStatus.underPickupProcess, lastStageUpdatedOn : moment().format(),
                            lastStageUpdatedBy : this.userObj.user.id}
                    this.updateRecord(orderId, obj, 'orders', 'loader1')
                }
              /* ----------------x--------------------x---------------x------------- */
            },
            async unlinkTruck(orderId, orderDetailId, stage){
                let obj = { transportVehicleAssignId: null}
                await this.updateRecord(orderDetailId, obj, 'orderDetails', 'loader1', false)

              /* -------- Change Order status to 'In Process Of Departure' --------- */
                if(stage === Constants.internalStatus.waitingForDeparture||
                   stage === Constants.internalStatus.atDestinationCityWarehouse||
                   stage === Constants.internalStatus.onTheWayToDropCityWarehouse) {

                    obj = { internalstatus: Constants.internalStatus.inProcessOfDeparture, lastStageUpdatedOn : moment().format(),
                            lastStageUpdatedBy : this.userObj.user.id}
                    this.updateRecord(orderId, obj, 'orders', 'loader1')
                }
              /* ----------------x--------------------x---------------x------------- */
            },
            addEwayBillDetails(id){
                let obj = { ewayBillNo: this.ewayBillNo, isEwayBillVerified: this.isEwayBillVerified }
                this.updateRecord(id, obj, 'orderDetails', 'loader1', false)
            },
            updateCarryBill(id){
                let value = this.carryBill === 'Yes' ? true : false
                let obj = { carryBill:  value}
                this.updateRecord(id, obj, 'orderDetails', 'loader1', false)
            },
            async onWaitingForDeparture(orderId, orderDetailId){
                this.errMessages = []
                let hasError = false
                if(!this.order.orderDetails.transportVehicleAssignId){
                    this.errMessages.push('Select Transport Vehicle')
                    hasError = true
                }
                if(!this.order.orderDetails.ewayBillNo){
                    this.errMessages.push('Please Enter Eway Bill No.')
                    hasError = true
                }
                if(!this.order.orderDetails.isEwayBillVerified){
                    this.errMessages.push('Please verify Eway Bill No.')
                    hasError = true
                }
                if(this.order.orderDetails.carryBill === null){
                    this.errMessages.push('Please complete carry Bill section')
                    hasError = true
                }
                if(!hasError){
                    await this.updateRecord(orderDetailId, {loadedInTruck: true}, 'orderDetails', 'loader1')

                    let obj = { internalstatus: Constants.internalStatus.waitingForDeparture, lastStageUpdatedOn : moment().format(),
                                lastStageUpdatedBy : this.userObj.user.id}
                    this.updateRecord(orderId, obj, 'orders', 'loader1')
                }
            },
            onWayToDropCityWarehouse(truckOrderId){
                let stageId = Constants.internalStatus.waitingForDeparture
                let updateBy_stageId = Constants.internalStatus.onTheWayToDropCityWarehouse
                this.verifyOrdersByTruckOrderIdAndStageId(truckOrderId, stageId, this.updateOrdersStatusUsingTruckOrderId, updateBy_stageId)
            },
            onAtDestinationCityWarehouse(truckOrderId){
                let stageId = Constants.internalStatus.onTheWayToDropCityWarehouse
                let updateBy_stageId = Constants.internalStatus.atDestinationCityWarehouse
                this.verifyOrdersByTruckOrderIdAndStageId(truckOrderId, stageId, this.updateOrdersStatusUsingTruckOrderId, updateBy_stageId)
            },
            async verifyOrdersByTruckOrderIdAndStageId(truckOrderId, stageId, callback, updateBy_stageId){
                this.loader1 = true
                let response = await this.$apollo.query({
                    query: VERIFY_ORDERS_BY_TRUCK_ORDER_ID_AND_STAGE_ID,
                    fetchPolicy: 'network-only',
                    variables: {
                        truckOrderId: truckOrderId,
                        stageId: stageId
                    }
                })
                if(response.data.orders.length){
                    this.errMessages = response.data.orders.map((obj) => obj.orderNumber)
                    this.loader1 = false
                }else{
                    callback(truckOrderId, updateBy_stageId)
                }
            },
            async updateOrdersStatusUsingTruckOrderId(truckOrderId, updateBy_stageId){
                let response = await this.$apollo.mutate({
                    mutation: UPDATE_ORDERS_AND_TRUCKORDER_STATUS_USING_TRUCK_ORDER_ID,
                    variables: {
                        truckOrderId: truckOrderId,
                        stageId: updateBy_stageId,
                        lastStageUpdatedOn : moment().format(),
                        lastStageUpdatedBy : this.userObj.user.id
                    }
                })
                if(response.data){
                    this.loader1 = false
                    this.$Message.success('Multiple Orders updated successfully!')
                    this.close()
                    this.closeModal()
                    this.finishEditing()
                }
            },
            async updateRecord(id, obj, table, loaderStr, closePopup = true){
                this[loaderStr] = true
                let response = await this.$apollo.mutate({
                    mutation: generate_UPDATE_ORDER_DATA(table),
                    variables: { id: id, obj: obj}
                })
                if(response.data){
                    this.$Message.success('Order updated successfully!')
                    this[loaderStr] = false
                    if(closePopup){
                       this.close()
                       this.closeModal()
                       this.finishEditing()
                    }
                }
            },
            refreshCurrentRecord(){
              console.log('refreshrecord')
              let screen = this.$parent.$parent.$parent.screen
              let ordersVariable = screen + '_orders'
              let pRow = this.hotInstance?.toPhysicalRow(this.row)                       //When accessing original array
              this.order = this.$parent.$parent.$parent[ordersVariable][pRow]

  /*  --- Automatically update to next stage if all actions are done in 'Under Pickup Process/In Proces of Departure'--- */
              if(this.order?.internalstatus === Constants.internalStatus.underPickupProcess){
                this.onReadyForPickup(this.order.id)
              }else if(this.order?.internalstatus === Constants.internalStatus.inProcessOfDeparture){
                this.onWaitingForDeparture(this.order.id, this.order.orderDetails.id)
              }
  /* --------------x----------------------x--------------------x------------------------x---------------------x---------- */
            },
            async insertCancelNote(orderId, cancelNote){
              let response = await this.$apollo.mutate({
                mutation: ADD_ORDER_NOTE,
                variables: {
                  orderId: orderId,
                  note: cancelNote,
                  type: 'CANCEL',
                  createdBy: JSON.parse(localStorage.getItem('tatkalorri')).userObj.user.id,
                  lastUpdatedBy: JSON.parse(localStorage.getItem('tatkalorri')).userObj.user.id,
                  createdOn: moment().format(),
                  updatedOn: moment().format()
                }
              })
              if(response.data){
                this.$Message.success('Order Note added successfully!');
              }
            },
            onAssignVehicle(){
                this.toDoStage = this.value === Constants.internalStatus.underPickupProcess?
                                 'assign_local_transport':'assign_transport_vehicle'
                this.showVehicle = true
            },
        },
        created(){
          bus.$on('refreshRecord', this.refreshCurrentRecord)
            // console.log('comp created Actionpopup')
        },
    }
</script>

<style scoped>
    /deep/ .ivu-select-item{
        padding: 0px 0px;
    }
    /deep/ .ivu-select-item-div{
        width: 100%;
        padding: 7px 16px;
    }
    /deep/ .ivu-tabs-nav .ivu-tabs-tab .ivu-icon{
        color: green;
    }
  /deep/ .action-modal>.ivu-modal>.ivu-modal-content>.ivu-modal-body{
    max-height: 410px !important;
    overflow-y: auto;
  }

</style>
<style>
    .exchange-icon{
        margin-left: 10px;
        margin-right: 10px;
        margin-top: auto;
        text-align: center;
        margin-bottom: auto;
    }
</style>
